// Imported first by the page's entries (main.tsx, conformance.ts), so the fetch wrapper is in place before anything,
// the engine included, can read a pack (src/data/packs.ts).
import { installPackPaths } from './packs.ts';

installPackPaths('/');
